import React, { useEffect } from 'react'
import { Button, Toast } from '@ow/comps'
import { IconMaps } from '@ow/icons'
import styled from '@emotion/styled'
import { pick, flatten } from 'lodash-es'
import { useBatchProcessStore, useTbViewStore, useAppStore } from '@vt/hooks'
import {
  getStageNextNodes,
  getDataStageBinding,
} from '@vt/apis/lib-ex/v2/process'

const StyledBtnContent = styled.div`
  padding: 24px;
  .top {
    margin-bottom: 12px;
    .close-btn {
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }
  }
  .btn-content {
    button + button {
      margin-left: 15px;
    }
  }
`

const Content = function ({ setShowContent, setOverlayVisible }) {
  const { appId } = useAppStore((x) => pick(x, ['appId']))
  const {
    processNodes,
    setCurrentNode,
    batchUpdateStageNode,
    setProcessNodes,
  } = useBatchProcessStore((state) =>
    pick(state, [
      'processNodes',
      'setCurrentNode',
      'batchUpdateStageNode',
      'setProcessNodes',
    ])
  )
  const {
    tbId,
    selectedIds,
    setSelectedIds,
    fetchTbData,
    setIsShowBatchOperate,
    setRefreshStatus,
  } = useTbViewStore((state) =>
    pick(state, [
      'tbId',
      'selectedIds',
      'setSelectedIds',
      'fetchTbData',
      'setIsShowBatchOperate',
      'setRefreshStatus',
    ])
  )

  const submitNode = (node) => {
    setCurrentNode(node)
    if (node.needForm) {
      // 需要显示新的表单内容
      setShowContent('form')
    } else {
      // 批量操作
      setOverlayVisible(true)
      batchUpdateStageNode({}, selectedIds)
        .then(() => {
          // 将选中数据清空
          setSelectedIds([])
          // 重新刷新表格数据
          fetchTbData()
          // 隐藏批量操作组件
          setIsShowBatchOperate(false)
          if (setRefreshStatus) {
            setRefreshStatus(true)
          }
          Toast.success({ title: `${selectedIds.length}条数据批量操作成功！` })
        })
        .finally(() => {
          setOverlayVisible(false)
        })
    }
  }

  // 获取操作节点
  const getNodes = (stageId) => {
    return new Promise((resolve) => {
      getStageNextNodes(appId, selectedIds[0], tbId, stageId).then((res) => {
        if (Array.isArray(res) && res.length === 0) {
          setIsShowBatchOperate(false)
          Toast.error({ title: `该状态下暂无操作！` })
          resolve([])
        } else {
          const result = (res || []).map((item) => {
            return { ...item, stageId }
          })
          resolve(result)
        }
      })
    })
  }
  useEffect(() => {
    // 获取显示的节点内容
    getDataStageBinding(appId, tbId).then((res) => {
      const arr = (res || []).map((item) => {
        return getNodes(item.stageId)
      })
      Promise.all(arr).then((result) => {
        setProcessNodes(flatten(result))
      })
    })
  }, [])

  return (
    <StyledBtnContent className="flex flex-col">
      <div className="top flex justify-between items-center">
        <p className="text-gray-100">批量操作</p>
        <div
          className="close-btn bg-primary-700 flex items-center justify-center cursor-pointer"
          onClick={() => {
            setIsShowBatchOperate(false)
          }}
        >
          <IconMaps type="close" fill="#fff" width={12} height={12} />
        </div>
      </div>
      <div className="btn-content flex">
        {(processNodes || []).map((node) => {
          return (
            <Button
              style={{
                padding: '5px 16px',
              }}
              onClick={() => {
                submitNode(node)
              }}
              type="primary"
            >
              {node.nodeName}
            </Button>
          )
        })}
      </div>
    </StyledBtnContent>
  )
}

export default Content
